import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../../ui/button/Button";
import SelectAutoComplete from "../../../ui/selectAutoComplete/SelectAutoComplete";
import { useState, useEffect } from "react";
import { getTiposNumeroTelefonico } from "../../functions/Soporte";

const NuevoTelefonoModal = ({
  open,
  onClose,
  onConfirm,
  API_URL,
  telefono = null,
}) => {
  const [tiposNumeros, setTiposNumeros] = useState([]);
  const [telefonoForm, setTelefonoForm] = useState({});

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const tiposNumerosRes = await getTiposNumeroTelefonico(API_URL);

      setTiposNumeros(tiposNumerosRes);
    };

    if (open) {
      fetchData();
    }
    if (telefono) {
      setTelefonoForm(telefono);
    }
  }, [open]);

  const handleClose = () => {
    onClose();
    setTelefonoForm({});
    setTiposNumeros([]);
  };

  const handleConfirm = async () => {
    if (
      !telefonoForm?.nombre ||
      !telefonoForm?.numeroTelefonico ||
      !telefonoForm?.tipoNumeroTelefonico
    ) {
      setSnackbarMessage("Por favor, complete los campos obligatorios.");
      setShowSnackbar(true);
      return;
    }
    onConfirm(telefonoForm);
    handleClose();
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Registro Telefónico</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
          }}
        >
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Nombre: *</label>
            <input
              className="form-input"
              placeholder="Nombre..."
              value={telefonoForm?.nombre || ""}
              onChange={(e) => {
                setTelefonoForm((prev) => ({
                  ...prev,
                  nombre: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Número telefónico: *</label>
            <input
              className="form-input"
              placeholder="Número telefónico..."
              value={telefonoForm?.numeroTelefonico || ""}
              onChange={(e) => {
                setTelefonoForm((prev) => ({
                  ...prev,
                  numeroTelefonico: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Correo:</label>
            <input
              className="form-input"
              placeholder="Correo..."
              value={telefonoForm?.correoElectronico || ""}
              onChange={(e) => {
                setTelefonoForm((prev) => ({
                  ...prev,
                  correoElectronico: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Tipo: *</label>
            <SelectAutoComplete
              label=""
              fieldC="name"
              options={tiposNumeros}
              value={telefonoForm.tipoNumeroTelefonico || ""}
              onChange={(e, value) =>
                setTelefonoForm((prev) => ({
                  ...prev,
                  tipoNumeroTelefonico: value,
                }))
              }
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default NuevoTelefonoModal;
